import React, { useCallback } from 'react';

import { formatTime } from 'utils/formatTime';

import {
  StyledJourney,
  StyledJourneyId,
  StyledJourneyStop,
  StyledLabel,
  StyledTime,
} from 'modules/assignment-cards/styled';

const JourneyItem = ({ isSelected, journey, onClick }) => {
  const journeyId = (journey || {}).id;

  const handleClick = useCallback(() => {
    if (!journeyId) {
      return;
    }
    onClick(journeyId);
  }, [journeyId, onClick]);

  if (!journey) {
    return null;
  }

  const {
    start_time_from,
    start_time_from_tz,
    start_time_to_tz,
    start_time_to,
    end_time_from,
    end_time_from_tz,
    end_time_to_tz,
    end_time_to,
    status,
  } = journey;

  const startTimeFormatted = formatTime({
    time_from: start_time_from,
    time_from_tz: start_time_from_tz,
    time_to_tz: start_time_to_tz,
    time_to: start_time_to,
  });

  const endTimeFormatted = formatTime({
    time_from: end_time_from,
    time_from_tz: end_time_from_tz,
    time_to_tz: end_time_to_tz,
    time_to: end_time_to,
  });

  const getStatusSkin = (status) => {
    if (status === 'ASSIGNED') {
      return 'pending';
    }

    if (status === 'IN_TRANSIT' || status === 'DONE' || status === 'DONE_WITHOUT_MANIFEST') {
      return 'in_progress';
    }

    if (status === 'CANCELLED') {
      return 'cancel';
    }

    return 'default';
  };

  const testId = (key, isSelected) => `${key}__${journey.id}${isSelected ? `__selected` : ''}`;

  return (
    <StyledJourney
      data-testid={testId('journey', isSelected)}
      onClick={handleClick}
      selected={isSelected}
      data-selected={isSelected}
    >
      <StyledJourneyId skin={getStatusSkin(status)} data-testid={testId('journey_id')}>
        J{journey.id}
      </StyledJourneyId>
      <StyledJourneyStop border>
        <StyledLabel data-testid={testId('label_from')} selected={isSelected}>
          {journey.label_from}
        </StyledLabel>
        <StyledTime data-testid={testId('time_from')} selected={isSelected}>
          {startTimeFormatted}
        </StyledTime>
      </StyledJourneyStop>
      <StyledJourneyStop>
        <StyledLabel data-testid={testId('label_to')} selected={isSelected}>
          {journey.label_to}
        </StyledLabel>
        <StyledTime data-testid={testId('time_to')} selected={isSelected}>
          {endTimeFormatted}
        </StyledTime>
      </StyledJourneyStop>
    </StyledJourney>
  );
};

export default JourneyItem;
